// @flow
import * as React from 'react'
import 'ta-semantic-ui/semantic/dist/components/card.css'
import 'ta-semantic-ui/semantic/dist/components/table.css'
import 'ta-semantic-ui/semantic/dist/components/label.css'
import 'ta-semantic-ui/semantic/dist/components/header.css'
import './styles.scss'
import { Property } from 'components/property'
import { TopImage } from 'components/topImage/component'

type Props = {
  address: string,
  category: string,
  className: string,
  description: string,
  host: string,
  image: string,
  winnerText: string,
  name: string,
  phone: string,
  previousRank: string,
  price: string,
  rank: number,
  stars: number,
  typeOfStay: string,
  website: string
}

export function Hotel({
  stars,
  website,
  category,
  image,
  winnerText,
  rank,
  previousRank,
  name,
  description,
  address,
  phone,
  host,
  typeOfStay,
  price,
  className = ''
}: Props) {
  // we're totally using array destructuring here, how fancy!
  const [hotelName, place] = name.split(', ')

  let starsArray = []
  let i = 0
  while (++i <= stars) {
    starsArray.push(i)
  }

  return (
    <a
      href={`http://${website}`}
      className={`ui link hotel ${className} card`}
      style={{ position: 'relative' }}
    >
      <TopImage
        current={rank}
        previous={previousRank}
        category={category}
        imageName={image}
      />

      <div className='content'>
        <h3 className={`ui ${+rank >= 11 ? 'small' : ''} header`}>
          {hotelName}
          <div className='meta sub header'>{place}</div>
          <div className='sub header'>{description}</div>
        </h3>
        <div className='winner text mobile only'>{winnerText}</div>
      </div>

      <table className='ui fixed small very compact definition attached unstackable striped table'>
        <tbody>
          <Property keyName='Adresse'>
            {address.split(', ')[0]}
            <br />
            {address.split(', ')[1]}
          </Property>

          <Property keyName='Telefon'>{phone}</Property>

          <Property keyName='Website'>
            <a href={`http://${website}`}>
              <i className='small external link icon' />
              {website}
            </a>
          </Property>

          {host !== '' && <Property keyName='Gastgeber'>{host}</Property>}

          <Property keyName={typeOfStay}>{price}</Property>
        </tbody>
      </table>
    </a>
  )
}

export default Hotel
